<template lang="html">
  <div class="choose-city-wrapper">
    <ul v-if="storeList.length > 0">
      <li
        v-for="item in storeList"
        @click="getStore(item)"
        :class="{ selected: item.departmentNo === collectStore.departmentNo }"
      >
        {{ item.store_desc }}
      </li>
    </ul>
    <empty text="该城市没有门店" v-else top="25%" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import empty from '@/components/common/empty'

export default {
  data() {
    return {
      storeList: []
    }
  },
  computed: {
    ...mapState(['collectStore', 'choosedCity'])
  },
  watch: {
    choosedCity(val, oldVal) {
      this.getStoreList(val.ID)
    }
  },
  methods: {
    ...mapMutations(['hideActionSheet']),
    getStore(item) {
      this.$store.commit('setCollectStore', item)
      this.hideActionSheet()
    },
    async getStoreList(citycode) {
      const json = await this.$store.dispatch('getStoreListByCitycode', {
        city_code: citycode
      })
      this.storeList = json.data || []
    }
  },
  created() {
    if (this.choosedCity && this.choosedCity.ID) {
      this.getStoreList(this.choosedCity.ID)
    }
  },
  components: {
    empty
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/mixin';

.choose-city-wrapper {
  min-height: 100%;
  margin-left: rem(20px);
  margin-right: rem(20px);

  ul {
    background-color: #fff;
  }
  li {
    height: rem(90px);
    line-height: rem(90px);
    font-size: rem(28px);
    color: #121212;
    @include border(bottom);
  }
  li.selected {
    color: #ff397e;
  }
}
</style>
